import Input from '../../common/Input';

const arrOfFields = [
  {
    "content": "",
    "created": new Date(),
    "id": null,
    "label": "Work Order",
    "order": 1,
    "detailsId": 1
  },
  {
    "content": "new",
    "created": new Date(),
    "id": null,
    "label": "Status",
    "order": 2,
    "detailsId": 2
  },
  {
    "content": "",
    "created": new Date(),
    "id": null,
    "label": "Description",
    "order": 5,
    "detailsId": 22
  },
  {
    "content": "",
    "created": new Date(),
    "id": null,
    "label": "Card Type",
    "order": 9,
    "detailsId": 25
  },
  {
    "content": "{}",
    "created": new Date(),
    "id": null,
    "label": "Paint List",
    "order": 12,
    "detailsId": 28
  }, {
    "content": "",
    "created": new Date(),
    "id": null,
    "label": "Priority",
    "order": 14,
    "detailsId": 26
  }, {
    "content": "",
    "created": new Date(),
    "id": null,
    "label": "Due date",
    "order": 15,
    "detailsId": 29
  }, {
    "content": "",
    "created": new Date(),
    "id": null,
    "label": "Shipping Date",
    "order": 16,
    "detailsId": 40
  },
  {
    "content": "",
    "created": new Date(),
    "id": null,
    "label": "Shipping Notes",
    "order": 17,
    "detailsId": 41
  }, {
    "content": "",
    "created": new Date(),
    "id": null,
    "label": "Pick Up Time",
    "order": 16,
    "detailsId": 33
  }, {
    "content": "",
    "created": new Date(),
    "id": null,
    "label": "Scope of Work",
    "order": 6,
    "detailsId": 35
  },
  {
    "content": "",
    "created": new Date(),
    "id": null,
    "label": "PO#",
    "order": 4,
    "detailsId": 36
  }, {
    "content": "",
    "created": new Date(),
    "id": null,
    "label": "Notes",
    "order": 18,
    "detailsId": 37
  },
  {
    "content": "",
    "created": new Date(),
    "id": null,
    "label": "Materials",
    "order": 8,
    "detailsId": 38
  },
  {
    "content": "",
    "created": new Date(),
    "id": null,
    "label": "Quality Control",
    "order": 8,
    "detailsId": 52
  },
  {
    "content": "",
    "created": new Date(),
    "id": null,
    "label": "Financial Info",
    "order": 12,
    "detailsId": 20
  }
];

function addEmptyFields(arr) {
  const arrDetailIds = [];

  for (let j = 0; j < arr.length; j++) {
    arrDetailIds.push(arr[j].detailsId);
  }

  for (let i = 0; i < arrOfFields.length; i++) {
    if (arrDetailIds.indexOf(arrOfFields[i].detailsId) === -1) {
      if (!arrOfFields[i].id) {
        arrOfFields[i].id = 'field_' + i;
      }
      arr.push(arrOfFields[i]);
    }
  }
}

export function bindFieldAndData(fields, fields_detail) {
  const newArr = [];
  for (let i = 0; i < fields.length; i++) {
    const currentFieldData = fields[i];
    const currentId = currentFieldData.jobcard_field_id;

    if (currentFieldData && currentId) {
      const currentFieldSettings = fields_detail[currentId];
      if (currentFieldSettings) {
        newArr.push({
          content: currentFieldData.content,
          created: currentFieldData.created,
          id: currentFieldData.id,
          label: currentFieldSettings.label,
          order: currentFieldSettings.order,
          detailsId: currentId,
        });
      }
    }
  }

  // 03.07 FIX
  addEmptyFields(newArr);

  return newArr;
}

export function getDataFieldType(settings) {
  let fieldType = null;

  if (settings && settings.options && settings.options.type) {
    fieldType = settings.type;

    switch (settings.options.type) {
      case 'External link':
        fieldType = 'link';
        break;
      case 'Free text field':
        fieldType = 'textbox';
        break;
      case 'Date picker':
        fieldType = 'datepicker';
        break;
      case 'Dropdown with options':
        fieldType = 'dropdown';
        break;
    }
  } else if (settings && !settings.options) {
    fieldType = settings.type;

    if (fieldType == 'status') {
      fieldType = 'dropdown';
    } else if (fieldType == 'textbox') {
      fieldType = 'textbox';
    }
  }

  return fieldType;
}

export function buildOptionsFromStr(fieldData) {
  if (fieldData && fieldData.options && fieldData.options.option && fieldData.options.option.length > 0) {
    let arrData = fieldData.options.option.split(';');

    if (arrData && arrData.length > 0) {
      const arrOptions = [];

      for (let i = 0; i < arrData.length; i++) {
        arrOptions.push({
          value: arrData[i],
          text: arrData[i],
        });
      }

      return arrOptions;
    }
  }

  return [];
}

function getStatus(status) {
  const statuses = {
    'new': 'New',
    'hold': 'Hold',
    'in_progress': 'In Progress',
    'hot': 'HOT',
    're_work': 'Re-work',
    'ready': 'Ready',
    'closed': 'Closed',
  };

  return statuses[status];
}

function getJc(currentData, source) {
  if (source[currentData.content]) {
    return source[currentData.content].label;
  }
}

export function getValue(currentField, currentData, source) {
  switch (currentData.label.toLowerCase()) {
    case 'status':
      return getStatus(currentData.content);
    case 'card type':
      return getJc(currentData, source);
  }
}



// WEBPACK FOOTER //
// ./src/containers/Task/data.js